import 'core-js';
import 'zone.js/dist/zone';

// ngx-mapbox-gl uses mapbox-gl-geocoder
(window as any).global = window;
